if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      
      onSubmitHandler(evt) {
        evt.preventDefault();
        this.productInfo = this.closest('product-info');
        let customAddButton = this.productInfo.querySelectorAll('.button-add-to__cart');
        let planVariantId = '';
        let sellingPlanId = '';
        let wrazzleVariantId = '';
        let selectedSimType = '';
        let retailPlanId = '';
        let deviceId = '';
        let relationId = Date.now().toString();
        let radioChecked = this.productInfo.querySelector('.addon-plan-selection:checked');
        let portNumber = this.productInfo.querySelector('#check-your-number');
        if(portNumber && this.form && portNumber.dataset.phoneNumber){
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'properties[portNumber]';
            input.className = 'input-hidden_relationId';
            input.value = portNumber.dataset.phoneNumber;
            this.form.appendChild(input);
        }
        if(radioChecked){
          let inputDataType = radioChecked.dataset.type;
          let eSimVariantId = radioChecked.dataset.esimVariantId;
          let pSimVariantId = radioChecked.dataset.psimVariantId;
          let wrazzleESimVariantId = radioChecked.dataset.wrazzleEsimVariantId;
          let wrazzlePSimVariantId = radioChecked.dataset.wrazzlePsimVariantId;
          deviceId = radioChecked.dataset.deviceVariantId;
          retailPlanId = radioChecked.dataset.retailPlanId;
          sellingPlanId = radioChecked.dataset.sellingPlanId;
          if(inputDataType == 'yes'){
            let simType = this.productInfo.querySelector('.sim-type-selection:checked');
            if (simType) {
              let inputChecked = simType.value;
              if (inputChecked === "pSIM") {
                planVariantId = pSimVariantId;
                wrazzleVariantId = wrazzlePSimVariantId;
                selectedSimType = 'psim';
              } else if (inputChecked === "eSIM") {
                planVariantId = eSimVariantId;
                wrazzleVariantId = wrazzleESimVariantId;
                selectedSimType = 'esim';
              }
            }
            if(this.form){
              var input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'properties[_relationId]';
              input.className = 'input-hidden_relationId';
              input.value = relationId;
              this.form.appendChild(input);
            }
          }else{
            if(this.form.querySelector('.input-hidden_relationId')){
              this.form.querySelector('.input-hidden_relationId').remove();
            }
          }
        }
       
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        
        const formData = new FormData(this.form);
        if (planVariantId) {
          formData.append('items[1][properties][_relationId]', relationId);
          formData.append('items[1][id]', planVariantId);
          formData.append('items[1][quantity]', 1);
          if(sellingPlanId){
            formData.append('items[1][selling_plan]', sellingPlanId);
          }
          if(retailPlanId){
            formData.append('items[1][properties][retailPlanId]', retailPlanId);
          }
          if(wrazzleVariantId){
            formData.append('items[1][properties][wrazzleVariantId]', wrazzleVariantId);
          }
          if(selectedSimType){
            formData.append('items[1][properties][simType]', selectedSimType);
          }
          if(deviceId){
            formData.append('items[1][properties][wrazzleVariantId]', deviceId);
          }
        }
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if(customAddButton){
              customAddButton.forEach(function(button){
                if(button.querySelector('.loading__spinner')){
                  button.querySelector('.loading__spinner').classList.add('hidden');
                }
              });
            }
            console.log(customAddButton)
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
